import { memo } from 'react';
import './style.css';
import { Card, Divider, Empty, Table } from 'antd';

const SingleTeamDetails = ({ team }) => {
    const toShowEndDate = () => {
        let endDate = new Date(team?.end).getFullYear();
        return endDate !== 1970;
    };

    const columns = [
        {
            title: 'Designation',
            dataIndex: 'designation',
        },
        {
            title: 'Name',
            dataIndex: 'name',
        },
        {
            title: 'Email',
            dataIndex: 'email',
        },
    ];

    return (
        <div className="single_team">
            <Card className="single_card">
                <div className="top_div">
                    <div className="start_date">
                        <strong>Start at: {'  '}</strong>
                        {new Date(team?.start).toLocaleString('en-IN')}
                    </div>
                    {toShowEndDate() && (
                        <div className="start_date">
                            <strong>End at: {'  '}</strong>
                            {new Date(team?.end).toLocaleString('en-IN')}
                        </div>
                    )}
                </div>
                <Divider style={{ margin: 0, padding: 0 }} />
                <div className="team_details">
                    <Table dataSource={team?.users} columns={columns} pagination={false} />
                </div>
            </Card>
        </div>
    );
};

const TeamInformation = ({ teamHistory }) => {
    const renderTeamHistory = dataOriginal => {
        let data = [...dataOriginal]?.reverse();
        if (data?.length) {
            return (
                <div className="team_history">
                    {data?.map((item, key) => {
                        return <SingleTeamDetails team={item} key={key} />;
                    })}
                </div>
            );
        } else {
            return (
                <Empty
                    style={{
                        width: '100%',
                        height: '100%',
                        display: 'flex',
                        justifyContent: 'center',
                        alignContent: 'center',
                        margin: 0,
                    }}
                />
            );
        }
    };

    return <div className="team_container">{renderTeamHistory(teamHistory)}</div>;
};

export default memo(TeamInformation);
